/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-15 17:38:33
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-03-11 21:27:24
 * @FilePath: \baishu_react_ui\src\Login\BsyRadioGroup\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import ReactDOM from "react-dom";
import { BsyUtils } from "../../utils/Utils";
import { BsyWidget } from "../BsyWidget";
import { BaseTable, features, TablePipeline } from "ali-react-table";
import _, { take } from "lodash";

import "./index.css";
import BsyCheckBox from "../BsyCheckBox";
import BsySubformRadioGroup from "../BsySubformRadioGroup";
import BsyComboCheckBox from "../BsyComboCheckBox";
import BsySubformCheckboxGroup from "../BsySubformCheckboxGroup";
import BsyButton from "../BsyButton";
import BsyComboBox from "../BsyComboBox";
import BsySubformAddress from "../BsySubformAddress";
import BsySubformImageUpload from "../BsySubformImageUpload";
import BsySubformFileUpload from "../BsySubformFileUpload";
import BsySubformSignature from "../BsySubformSignature";
import BsySelectUser from "../BsySelectUser";
import BsySelectDept from "../BsySelectDept";
import BsySelectUserGroup from "../BsySelectUserGroup";
import BsySelectDeptGroup from "../BsySelectDeptGroup";
import BsyTextArea from "../BsyTextArea";
import BsyIconBtn from "../BsyIconBtn";
import BsyDialog from "../BsyDialog";
import BsySubformImportPane from "../BsySubformImportPane";
import BsyMsgBubble from "../BsyMsgBubble";
import BsySubformLinkData from "../BsySubformLinkData";
import BsySubformLinkQuery from "../BsySubformLinkQuery";
import BsyFormLoadData from "../BsyFormLoadData";
import BsySubformLocation from "../BsySubformLocation";
import BsyLinkData from "../BsyLinkData";
import BsyLinkQuery from "../BsyLinkQuery";
import BsyRadioGroup from "../BsyRadioGroup";
import BsyCheckGroup from "../BsyCheckGroup";
import { memoryWidget } from "../../utils/rowExecuteRely_3_0";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyAlertMenu from "../BsyAlertMenu";
import BsyFileUpload from "../BsyFileUpload";
import BsyImageUpload from "../BsyImageUpload";
import BsySignature from "../BsySignature";
import { SUBFORM_MAX_LIMIT } from "../../global/BsyConfig";
import BsyAlert from "../BsyAlert";
import Sortable from "sortablejs";
import { dayjsUtils } from "../../utils/dayjsUtils";

export default class BsySubform extends BsyWidget {
  constructor(props) {
    super({
      baseCls: "bsy-subform",
      allowBlank: !0,
      ignoreOptAuth: !1,
      items: [],
      itemPadding: 12,
      itemShowCount: 10,
      maxItemCount: SUBFORM_MAX_LIMIT,
      newItemText: React.language("add"),
      noFieldText: React.language("field.add"),
      needEvent: !0,
      label: "",
      mode: "edit",
      showMode: "form", //form 走普通方式， dataManager 走通用模式
      onBeforeRowEdit: null,
      onBeforeWidgetCreate: null,
      onAfterWidgetCreate: null,
      onRowChange: null,
      onRowRender: null, //行重绘
      rowHeadWidth: 80,
      rowBorder: 1,
      rowHeight: 40,
      rowBottom: 25,
      tipWidth: null,
      rootElement: null, //用于页面展开
      subFieldShowRules: [],
      subform_create: !0,
      subform_insert: props.hasOwnProperty("subform_insert")
        ? props.subform_insert
        : false,
      subform_edit: !0,
      subform_sort: !1,
      subform_delete: !0,
      subform_import: !0,
      subform_dataload: !0,
      onStopEdit: null,
      onStateChange: null,
      onGetFormData: null,
      scrollLeft: 0, //底部滚动条的位置
      renderMode: null, //刷新决定是否调用滚动条的位置
      design: !1,
      isformdata: false,
      onRenderSucess: null,
      subformloaddataTitle: React.language("data.loading"),
      ...props,
    });
    if (this.options.showMode !== "dataManager") {
      this.makeHeader();
    }
    this.state = {
      pipelineState: {},
      columns: [],
      showFieldsMeta: this._getColSizeMap(),
      isBatchDelete: false,
      isCheckAll: false,
      selectDataId: [],
    };
    this.lastcolumnResize = []; //记录历史最后一次的的详细情况，防止同样的规则也重复操作
    this.subformComponents = [];
    this.dataTable = [];
    this.hideCols = [];

    this.isfullscreen = false;
    this.dataSource = [];
    this.dataVisibleMap = [];
    this.widgetErrorMap = this.options.widgetErrorMap;
    this.errorWidgets = [];
    this.widgetItmesAll = [];
    this.element = React.createRef();
    this.getItemMap();
    this.renderIndex = 0;
    this.makeData();
    this.checkRefMap = {};
    // 更新css
    this.styleId = `style-subform-${this.options.widgetName}-${window.FX.STATIC
      .zIndex++}`;
  }

  getCSS = (flowRow) => {
    const { items, sticky_column = {} } = this.options;
    let id = this.styleId;
    let cssStr = "";
    let hideColsMap = {};
    const { limit = 0, enable = false } = sticky_column;
    let stickyIindex = 0;
    let widgetWidth = 80;
    let widgetLeft = widgetWidth; //有冻结的表头

    if (this.holder) {
      flowRow = flowRow || parseInt(this.holder.getAttribute("row-idx"));
    }

    items.map((item, index) => {
      let visible = this.getFieldVisible(item.widget.widgetName);

      if (visible === false) {
        // 处理整个列隐藏
        cssStr += `.${id} .art-table-body .${item.widget.widgetName} {display:none !important;}\n`;
        cssStr += `.${id} .art-table-header .th-${item.widget.widgetName} {display:none !important;}\n`;
        cssStr += `.${id} .art-table-body colgroup col:nth-child(${index + 2
          }) {display:none !important;}\n`;
        cssStr += `.${id} .art-table-header colgroup col:nth-child(${index + 2
          }) {display:none !important;}\n`;
        hideColsMap[item.widget.widgetName] = true;

        if (flowRow !== undefined) {
          cssStr += `.${id} .subform-row .subform-cell.${item.widget.widgetName} {display:none !important;;} \n`;
        }
      } else {
        const width = this._getColumnSize(item.widget);

        if (enable) {
          if (stickyIindex < limit) {
            cssStr += `.${id} .art-table-body .${item.widget.widgetName} {z-index:1;position:sticky !important;left:${widgetLeft}px;}\n`;
            cssStr += `.${id} .art-table-header .th-${item.widget.widgetName} {z-index:1;position:sticky !important;left:${widgetLeft}px;}\n`;
            stickyIindex++;

            widgetLeft += width;
          }
        }
      }
      return null;
    });
    if (widgetLeft > widgetWidth) {
      document.querySelector(`.${id} .art-lock-shadow-mask`).style.width = `${widgetLeft + 20
        }px`;
    }

    BsyUtils.forEach(this.subVisibleMap, (row, Object) => {
      BsyUtils.forEach(Object, (key, visible) => {
        if (hideColsMap[key]) {
          //跳过整个列隐藏
          return;
        }

        if (visible === false) {
          cssStr += `.${id} .row-${row}-${key} .sub-cell {display:none;} \n`;

          if (parseInt(flowRow) === parseInt(row)) {
            cssStr += `.${id} .subform-row .subform-cell.${key} {display:none;} \n`;
          }
        }
      });
    });
    return cssStr;
  };

  updateScRoll = () => {
    if (this.element.current) {
      if (this.element.current.querySelector(".art-table-header tr")) {
        const w = this.element.current.querySelector(
          ".art-table-header tr"
        ).offsetWidth;
        const tableWidth =
          this.element.current.querySelector(".art-table").offsetWidth;
        if (w > tableWidth) {
          this.element.current.querySelector(
            ".art-sticky-scroll"
          ).style.display = "block";
        } else {
          this.element.current.querySelector(
            ".art-sticky-scroll"
          ).style.display = "none";
        }
        if (this.element.current.querySelector(".art-sticky-scroll-item")) {
          this.element.current.querySelector(
            ".art-sticky-scroll-item"
          ).style.width = `${w}px`;
        }
      }
    }
    this.hasXScroll();
  };

  componentWillUnmount() {
    BsyUtils.removeStyle(this.styleId);
  }

  componentDidMount() {
    super.componentDidMount();
    const that = this;
    const { sortable, enable } = this.options;
    BsyUtils.writeStyle(this.styleId, this.getCSS());
    this.updateScRoll();

    if (this.options.isformdata) {
      this.refresh();
      return;
    }
    if (enable && sortable) {
      setTimeout(() => {
        const el = that.element.current.querySelector(".art-table-body tbody");
        new Sortable(el, {
          animation: 150,
          handle: ".icon-drag",
          ghostClass: "sortable-ghost",
          chosenClass: "sortable-chosen",
          dragClass: "sortable-drag",
          onEnd: ({ newIndex, oldIndex, target }) => {
            console.log(`new:${newIndex} old:${oldIndex}`);
            this.setValue(
              BsyUtils.swapArrayElements(that.dataSource, newIndex, oldIndex),
              () => {
                // 走删除逻辑，需要重置触发一遍相关的字段公式
                BsyUtils.applyFunc(
                  that,
                  that.options.onStopEdit,
                  [null, {}, that, "subform-delete"],
                  !1
                );
              }
            );
          },
        });
      }, 100);
    }
  }

  rwoMenuHandle = (rowIndex, type, e) => {
    const { maxItemCount } = this.options;
    let data = Object.assign({}, this.dataSource[rowIndex]);
    if (this.dataSource.length >= maxItemCount) {
      tipAlert({
        type: "warning",
        msg: React.language("subform.maxCountTip", {
          limit: maxItemCount,
        }),
      });
      return;
    }

    let nowIndex = data.rowIdx;
    data.id = undefined;
    data.rowId = undefined;
    data.isNew = true;
    data.status = "new";
    console.log("rwoMenuHandle", data);
    switch (type) {
      case "copy-next": {
        let tmpdata = [];
        for (let index = 0; index < this.dataSource.length; index++) {
          let element = Object.assign({}, this.dataSource[index]);
          if (element.rowIdx == nowIndex) {
            tmpdata.push(element);
            data.order = index + 2;
            data.rowIdx = index + 1;
            data.isCopy = true;
            tmpdata.push(data);
          } else if (element.rowIdx > nowIndex) {
            data.order = tmpdata.length;
            data.rowIdx = tmpdata.length - 1;
            tmpdata.push(element);
          } else {
            tmpdata.push(element);
          }
        }

        this.value = [...tmpdata];
        this.dataSource = [...tmpdata];
        break;
      }
      case "copy-last": {
        this.addstatus = true;
        data.order = this.dataSource.length;
        data.rowIdx = this.dataSource.length - 1;
        data.isCopy = true;
        this.dataSource.push(data);
        break;
      }
      case "insert-up": {
        let tmpdata = [];
        for (let index = 0; index < this.dataSource.length; index++) {
          let element = Object.assign({}, this.dataSource[index]);
          if (element.rowIdx == nowIndex) {
            let v = {
              // rowId: newId,
              // id: newId,
              rowIdx: index,
              order: index + 1,
              isNew: true,
              status: "new",
            };
            tmpdata.push(v);
            element.order = index + 2;
            element.rowIdx = index + 2;
            tmpdata.push(element);
          } else if (element.rowIdx > nowIndex) {
            data.order = tmpdata.length;
            data.rowIdx = tmpdata.length - 1;
            tmpdata.push(element);
          } else {
            tmpdata.push(element);
          }
        }
        this.dataSource = [...tmpdata];
        break;
      }
      case "insert-next": {
        let tmpdata = [];
        for (let index = 0; index < this.dataSource.length; index++) {
          let element = Object.assign({}, this.dataSource[index]);
          if (element.rowIdx == nowIndex) {
            tmpdata.push(element);

            let v = {
              // rowId: newId,
              // id: newId,
              rowIdx: index + 1,
              order: index + 2,
              isNew: true,
              status: "new",
            };
            tmpdata.push(v);
          } else if (element.rowIdx > nowIndex) {
            data.order = tmpdata.length;
            data.rowIdx = tmpdata.length - 1;
            tmpdata.push(element);
          } else {
            tmpdata.push(element);
          }
        }
        this.dataSource = [...tmpdata];
        break;
      }
      case "delete": {
        this.delRow(rowIndex, e);
        break;
      }
      default:
    }
    BsyUtils.applyFunc(
      this,
      this.options.onStopEdit,
      [this.getValue(), null, this],
      !1
    );
  };

  rowMoreMenu = (rowIndex, rowData) => {
    const { subform_create, subform_insert, subform_delete, sortable } =
      this.options;

    if (subform_create && subform_insert) {
      return (
        <i
          className="head-icon icon-bsy-icongengduo1 "
          onClick={(event) => {
            let bts = [];
            if (subform_insert) {
              bts.push({
                icon: "",
                text: React.language("field.subform.copy.next"),
                click: (ref, Event) => {
                  Event.stopPropagation();
                  this.rwoMenuHandle(rowIndex, "copy-next");
                },
              });
            }

            if (subform_create) {
              bts.push({
                icon: "",
                text: React.language("field.subform.copy.end"),
                click: (ref, Event) => {
                  Event.stopPropagation();
                  this.rwoMenuHandle(rowIndex, "copy-last");
                },
              });
            }
            if (subform_insert) {
              bts.push({
                icon: "",
                text: React.language("field.subform.insert.up"),
                click: (ref, Event) => {
                  Event.stopPropagation();
                  this.rwoMenuHandle(rowIndex, "insert-up");
                },
              });
              bts.push({
                icon: "",
                text: React.language("field.subform.insert.next"),
                click: (ref, Event) => {
                  Event.stopPropagation();
                  this.rwoMenuHandle(rowIndex, "insert-next");
                },
              });
            }

            if (sortable && (subform_delete || rowData.isNew)) {
              bts.push({
                icon: "",
                color: "var(--bsy-base-error-color)",
                text: React.language("api.deleteData"),
                click: (ref, Event) => {
                  Event.stopPropagation();
                  this.rwoMenuHandle(rowIndex, "delete", event);
                },
              });
            }
            BsyAlertMenu({
              item: bts,
              width: "auto",
              target: event.target,
              onClose: () => {
                return !0;
              },
            });
          }}
        ></i>
      );
    }
    if (subform_create) {
      return (
        <i
          className="head-icon icon-bsy-icongengduo1 "
          onClick={(event) => {
            let bts = [];

            if (subform_create) {
              bts.push({
                icon: "",
                text: React.language("field.subform.copy.end"),
                click: (ref, Event) => {
                  Event.stopPropagation();
                  this.rwoMenuHandle(rowIndex, "copy-last");
                },
              });
            }

            if (sortable && (subform_delete || rowData.isNew)) {
              bts.push({
                icon: "",
                color: "var(--bsy-base-error-color)",
                text: React.language("api.deleteData"),
                click: (ref, Event) => {
                  Event.stopPropagation();
                  this.rwoMenuHandle(rowIndex, "delete", event);
                },
              });
            }
            BsyAlertMenu({
              item: bts,
              width: "auto",
              target: event.target,
              onClose: () => {
                return !0;
              },
            });
          }}
        ></i>
      );
    }
    if (subform_create) {
      return (
        <i
          className="head-icon icon-bsy-enterprise-log"
          onMouseEnter={(event) => {
            window.FX.UI.showPopover({
              anchor: window.$(event.target),
              content: window
                .$("<span/>")
                .text(React.language("field.subform.copy.end")),
              type: "dark",
            });
          }}
          onMouseLeave={() => {
            window.FX.UI.closePopover();
          }}
          onClick={(e) => {
            this.rwoMenuHandle(rowIndex, "copy-last");
          }}
        ></i>
      );
    }
  };

  getTextareaTextHeight = (row, textareas) => {
    const rowVal = this.dataSource[row];
    let hei = textareas
      .map((it) => {
        return (rowVal[it] || "").split("\n").length;
      })
      .sort()
      .reverse();
    console.log(hei);
    return hei[0] * 19 + 20;
  };

  scrollInvalidWidgetToView = () => {
    const that = this;
    const { current } = this.element;
    if (!current) {
      return;
    }
    console.log("scrollInvalidWidgetToView");
    let element = current.querySelector(".chart-data-border");
    if (!element) {
      return;
    }
    console.log(this.widgetErrorMap);
    const { items } = this.options;
    const idx = this.widgetErrorMap.errs[0].idx;
    const name = this.widgetErrorMap.errs[0].name;
    const textareas = items
      .map((it) => {
        if (it.widget.type === "textarea") return it.widget.widgetName;
        return null;
      })
      .filter((it) => it);
    const lineHeight = 43; // 默认行高

    if (textareas.length) {
      let top = idx * lineHeight;
      for (let index = 0; index < idx; index++) {
        const element = this.getTextareaTextHeight(index, textareas);
        top += element > lineHeight ? element : lineHeight;
      }
      element.scrollTop = top;
    } else {
      const top = idx * lineHeight;
      element.scrollTop = top;
    }
    setTimeout(() => {
      const scrollEl = current.querySelector(`tr[rowidx='${idx}']`);
      if (scrollEl) {
        const td = scrollEl.querySelectorAll("td");

        let left = 0;
        for (let index = 0; index < td.length; index++) {
          const ele = td[index];
          if (ele.classList.contains("lock-left")) {
            continue;
          }

          const names = name.split(".");
          if (ele.classList.contains(names[1])) {
            current.querySelector(".art-sticky-scroll").scrollLeft = left;
            return;
          }
          left += ele.offsetWidth;
        }
      }
    }, 60);
  };

  getWidgetByName = (name, row) => {
    let that = this;
    let ret = [];

    for (let i = 0; i < this.dataSource.length; i++) {
      let id = this.dataSource[i].id || this.dataSource[i].rowId;
      if (this.itemMap[name]) {
        let widget = that.getSubformWidgetByName(name, id, row);
        ret.push(widget);
      }
    }

    if (BsyUtils.isNumber(row) && row > -1) {
      return ret[row] ? ret[row] : null;
    }
    return ret;
  };

  _getColumnSize = (a) => {
    let e = a.widgetName;
    if (BsyUtils.isObjectEmpty(this.columnSizeMap)) {
      let d = {};
      BsyUtils.forEach(this.state.showFieldsMeta, function (a, b) {
        d[a] = b;
      });
      this.columnSizeMap = d;
    }
    let f = this.columnSizeMap[e];
    if (f) return f;
    return BsyUtils.getSubformWidgetWidth(a);
  };

  getColumnLock = (index) => {
    const { sticky_column } = this.options;

    if (sticky_column && sticky_column.enable) {
      if (sticky_column.limit > index) {
        return true;
      }
    }

    return false;
  };

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    const { current } = this.element;
    let scrollTop = null;

    if (current) {
      let element = current.querySelector(".chart-data-border");
      if (element) {
        scrollTop = element.scrollTop;
      }
    }

    // this.setState({}, () => {
    //   if (scrollTop !== null) {
    //     let element1 = current.querySelector(".chart-data-border");
    //     if (element1) {
    //       element1.scrollTop = scrollTop;
    //     }
    //   }
    //   this.hasXScroll();
    // });
  }

  checkEventItemsVisible = (widgetName) => {
    //处理后台返回的属性
    if (this.itemsvisible) {
      if (this.itemsvisible.hasOwnProperty(widgetName)) {
        if (this.itemsvisible[widgetName] === false) {
          return false;
        }
      }
    }
    return true;
  };

  checkIsAll = (dataid) => {
    return (
      this.dataSource.filter((it) => {
        return dataid.includes(it.id);
      }).length === this.dataSource.length
    );
  };

  makeHeader = () => {
    const that = this;
    const { items, rowHeadWidth, ignoreOptAuth, isformdata, sortable, enable } =
      this.options;
    const { isBatchDelete, isCheckAll, selectDataId } = this.state;
    this.columns = [
      isBatchDelete
        ? {
          code: "isCheck",
          name: (
            <>
              <BsyCheckBox
                value={isCheckAll}
                getContext={(e) => {
                  this.AllCheckContext = e;
                }}
                onChange={(e) => {
                  if (e) {
                    that.setState({
                      selectDataId: that.dataSource.map((it) => it.id),
                      isCheckAll: true,
                    });
                    this.AllCheckContext.setValue(true);
                  } else {
                    that.setState({
                      selectDataId: [],
                      isCheckAll: false,
                    });
                    this.AllCheckContext.setValue(false);
                  }
                }}
              />
            </>
          ),
          width: 50,
          lock: true,
          features: { sortable: false, autoRowSpan: this.autoRowSpan },
          align: "center",
          render: (value, record, rowIndex) => {
            return (
              <>
                <BsyCheckBox
                  getContext={(context) => {
                    that.checkRefMap[record.id] = context;
                  }}
                  value={selectDataId.includes(record.id)}
                  onChange={(e) => {
                    const val = e
                      ? [...that.state.selectDataId, record.id]
                      : that.state.selectDataId.filter((it) => {
                        return record.id !== it;
                      });
                    let isAll = that.checkIsAll(val);
                    that.setState({
                      selectDataId: val,
                      isCheckAll: isAll,
                    });
                    this.AllCheckContext.setValue(isAll);
                  }}
                />
              </>
            );
          },
        }
        : {
          code: "order",
          name: (
            <div className="fix-col-head">
              <i
                className="head-icon icon-ui-expand"
                onClick={() => {
                  this.isfullscreen = !this.isfullscreen;
                  let el =
                    this.element.current.closest(".fl-widget") ||
                    this.element.current.closest(".widget-data");
                  if (this.isfullscreen) {
                    el.style.height =
                      this.element.current.offsetHeight + "px";
                    this.element.current.classList.add("fullscreen");
                    const brot = BsyUtils.closestClass(
                      this.element.current,
                      "bsy-frame-content"
                    );
                    if (brot) {
                      const leftMenu =
                        document.querySelector(".bsy-frame-menu");
                      if (leftMenu) {
                        leftMenu.style.display = "none";
                      }
                    }
                  } else {
                    el.style.height = "";
                    this.element.current.classList.remove("fullscreen");
                    const brot = BsyUtils.closestClass(
                      this.element.current,
                      "bsy-frame-content"
                    );
                    if (brot) {
                      const leftMenu =
                        document.querySelector(".bsy-frame-menu");
                      if (leftMenu) {
                        leftMenu.style.display = "";
                      }
                    }
                  }
                }}
              ></i>
              <i
                className="head-icon icon-contract"
                onClick={() => {
                  let el =
                    this.element.current.closest(".fl-widget") ||
                    this.element.current.closest(".widget-data");
                  el.style.height = "";
                  this.element.current.classList.remove("fullscreen");
                  const brot = BsyUtils.closestClass(
                    this.element.current,
                    "bsy-frame-content"
                  );
                  if (brot) {
                    const leftMenu =
                      document.querySelector(".bsy-frame-menu");
                    if (leftMenu) {
                      leftMenu.style.display = "";
                    }
                  }
                }}
              />

              {this._allowDelete() ? (
                <i
                  className="head-icon icon-trasho"
                  onClick={(e) => {
                    that.setState({
                      isBatchDelete: !this.state.isBatchDelete,
                    });
                  }}
                ></i>
              ) : (
                ""
              )}
            </div>
          ),
          widgetType: "number",
          width: rowHeadWidth,
          align: "center",
          lock: true,
          render: (value, record, rowIndex) => {
            return (
              <div className="row-head" row-idx={rowIndex}>
                <div className="row-num">{value}</div>
                <i
                  className="head-icon icon-ui-expand"
                  onClick={() => {
                    this.expandRow(rowIndex);
                  }}
                ></i>
                {sortable && enable ? (
                  <i className="head-icon icon-drag "></i>
                ) : (
                  ""
                )}
                {!sortable && (this._allowDelete() || record.isNew) ? (
                  <i
                    className="head-icon icon-trasho "
                    onClick={(e) => {
                      this.delRow(rowIndex, e);
                    }}
                  ></i>
                ) : (
                  ""
                )}
                {this.rowMoreMenu(rowIndex, record)}
              </div>
            );
          },
        },
    ];
    let stickyIndex = 0;
    for (let index = 0; index < items.length; index++) {
      const element = JSON.parse(JSON.stringify(items[index]));
      const { widgetName, type } = element.widget;
      let label = this.getFieldLabel(element.widget.widgetName);
      let visible = true;
      // = this.getFieldVisible(element.widget.widgetName);
      // if (this.options.ignoreOptAuth) {
      //   visible = true;
      // }

      let node = {
        code: widgetName,
        name:
          element.widget.labelHidden === true ? (
            ""
          ) : (
            <>
              {element.widget.allowBlank === false ? (
                <span className="label-notnull">*</span>
              ) : (
                ""
              )}{" "}
              <span
                className="form-cell"
                dangerouslySetInnerHTML={{ __html: label }}
              ></span>
            </>
          ),
        widgetType: type,
        width: this._getColumnSize(element.widget),
        align: "left",
        orgField: { ...element },
        headerCellProps: {
          className: `${type} th-${widgetName}`,
        },
        render: (value, record, rowIndex) => {
          return this.renderCustomCell(value, record, rowIndex, element);
        },
      };

      switch (node.widgetType) {
        case "linkdata": {
          if (!BsyUtils.isObjectEmpty(element.widget.linkFields)) {
            node.width = element.widget.linkFields.length * 150 + 45;
            node.headerCellProps = {
              className: `${type} th-${widgetName}`,
              style: {
                minWidth: `${node.width}px`,
              },
            };
            node.name = (
              <>
                {element.widget.linkFields.map((e, k) => {
                  return k === 0 ? (
                    <>
                      <div
                        className="sub-link-title sub-linkdata select-data"
                        style={{
                          width: 35,
                          border: "none",
                          verticalAlign: "middle",
                        }}
                      ></div>
                      <div
                        className="sub-link-title sub-linkdata"
                        style={{ width: 150, border: "none" }}
                      >
                        {e.text}
                      </div>
                    </>
                  ) : (
                    <div
                      className="sub-link-title sub-linkdata"
                      style={{ width: 150 }}
                    >
                      {e.text}
                    </div>
                  );
                })}
              </>
            );
          } else {
            node.width = 150 + 10;
            node.headerCellProps = {
              className: node.widgetType,
              style: {
                minWidth: `${node.width}px`,
              },
            };
            node.name = (
              <>
                <div
                  className="form-cell"
                  style={{ width: 150 }}
                  dangerouslySetInnerHTML={{
                    __html: element.widget.labelStyle || element.label,
                  }}
                ></div>
              </>
            );
          }
          break;
        }
        case "linkquery": {
          if (!BsyUtils.isObjectEmpty(element.widget.linkFields)) {
            if (element.widget.showType == "label") {
              node.width = 150 + 10;
              node.headerCellProps = {
                className: `${type} th-${widgetName}`,
                style: {
                  minWidth: `${node.width}px`,
                },
              };
              node.name = (
                <>
                  <div
                    className="sub-link-title sub-linkquery"
                    style={{ width: 150 }}
                  >
                    {element.label}
                  </div>
                </>
              );
            } else {
              node.width = element.widget.linkFields.length * 150 + 10;
              node.headerCellProps = {
                className: `${type} th-${widgetName}`,
                style: {
                  minWidth: `${node.width}px`,
                },
              };
              node.name = (
                <>
                  {element.widget.linkFields.map((e) => {
                    return (
                      <div
                        className="sub-link-title sub-linkquery"
                        style={{ width: 150 }}
                      >
                        {e.text}
                      </div>
                    );
                  })}
                </>
              );
            }
          } else {
            node.width = 150 + 10;
            node.headerCellProps = {
              className: `${type} th-${widgetName}`,
            };
            node.name = (
              <>
                {isformdata ? (
                  <div className="form-cell" style={{ width: 150 }}>
                    {element.label}
                  </div>
                ) : (
                  <div
                    className="form-cell"
                    style={{ width: 150 }}
                    dangerouslySetInnerHTML={{
                      __html: element.widget.labelStyle || element.label,
                    }}
                  ></div>
                )}
              </>
            );
          }

          break;
        }
        default: {
          break;
        }
      }

      if (ignoreOptAuth || visible) {
        // node.lock = this.getColumnLock(stickyIndex);
        // stickyIndex++;
        this.columns.push(node);
      }
    }

    this.columns.push({
      code: "blank",
    });
  };

  _updateRowEditor = () => {
    let that = this;
    const { ignoreOptAuth } = this.options;
    if (ignoreOptAuth) return;
    const { current } = this.element;
    if (!current) {
      return;
    }

    let elements = current.querySelectorAll(
      ".chart-data-border .art-table-body tr .sub-cell"
    );
    for (let index1 = 0; index1 < elements.length; index1++) {
      elements[index1].style.display = "";
    }

    // let showPage =

    // if(   this.holder.setAttribute('row-idx', row))

    let rowDf = null;
    if (this.holder) {
      rowDf = parseInt(this.holder.getAttribute("row-idx"));
    }

    // let bodyTr = current.querySelectorAll(
    //   ".chart-data-border .art-table-body tr"
    // );
    // for (let index1 = 0; index1 < bodyTr.length; index1++) {
    //   let row = bodyTr[index1].getAttribute("rowidx");

    //   BsyUtils.forEach(this.subVisibleMap[row], (key, component) => {
    //     if (rowDf == row) {
    //       //config.widgetName
    //       if (that.holder) {
    //         let d = that.holder.querySelector(".subform-cell." + key);
    //         if (d) {
    //           // componenMap
    //           that.expandContext.componenMap[key].setVisible(component);
    //           // d.classList.remove('bsy-ui-hidden');
    //           d.style.display = "";
    //           if (component === false) {
    //             d.style.display = "none";
    //           }
    //         }
    //       }
    //     }

    //     let rel = bodyTr[index1].querySelector("." + key + " .sub-cell");
    //     if (rel) {
    //       rel.classList.remove("bsy-ui-hidden");
    //       if (component === false) {
    //         rel.classList.add("bsy-ui-hidden");
    //       }
    //     }
    //   });
    // }
  };

  setSubVisibleMap = (t, subColumnVisibleMaps) => {
    // let that = this;
    this.subColumnVisibleMaps = { ...subColumnVisibleMaps };
    if (!_.isEqual(this.subVisibleMap, t)) {
      this.subVisibleMap = { ...t };

      BsyUtils.writeStyle(this.styleId, this.getCSS());
      this.updateScRoll();

      // this._updateRowEditor(t);
      // // this._beforeHideColumn();
      // this.setState({}, () => {
      //   this.hasXScroll();
      // });
    }
  };

  getItemMap = () => {
    let that = this;
    that.itemMap = {};
    const { items } = this.options;
    for (let i = 0; i < items.length; i++) {
      if (!that.itemMap.hasOwnProperty(items[i].widget.widgetName)) {
        that.itemMap[items[i].widget.widgetName] = items[i].widget;
      }
    }
  };

  clearData = () => {
    let that = this;
    let opt = this.options;
    this.dataSource = [];
    this.subformComponents = [];
    this.dataTableField = [];
    BsyUtils.applyFunc(that, opt.onDeleteAll, [this.options.widgetName], !1);
  };

  makeData = () => {
    const { items } = this.options;
    let that = this;
    let opt = this.options;
    this.subformComponents = [];
    this.dataTableField = [];
    this.dataSource = this.unifiedValueFormat(this.value);
    // this.toDataVisible();
    if (this.dataSource.length === 0) {
      this.clearData();
      return;
    }

    for (let i = 0; i < this.dataSource.length; i++) {
      var rowValue = {
        ...this.dataSource[i],
        rowIdx: i,
        order: i + 1,
      };

      var id = rowValue.rowId || rowValue.id || BsyUtils.Ids24();
      rowValue.id = id;
      rowValue.rowId = id;
      var rowComponents = {
        rowIdx: i,
        order: i + 1,
        rowId: id,
        id: id,
      };
      this.dataTableField.push({});
      this.subformComponents.push(rowComponents);
      for (let i1 = 0; i1 < items.length; i1++) {
        let tmpitems = JSON.parse(JSON.stringify(items[i1]));

        let data = { ...tmpitems.widget };
        let widgetName = data.widgetName;

        // if (opt.mode != 'edit' && this.dataSource[i].isNew) {
        BsyUtils.applyFunc(
          this,
          this.options.onBeforeInit,
          [data.value, null, this, data],
          !1
        );
        if (!this.dataSource[i].hasOwnProperty(widgetName)) {
          //元素不存在，走默认值逻辑
          var val = this.getItemDefaultValue(data);
          if (!BsyUtils.isObjectEmpty(val)) {
            rowValue[widgetName] = val;
          }
        }
        // }

        let v = rowValue
          ? rowValue.hasOwnProperty(widgetName)
            ? rowValue[widgetName]
            : null
          : null;
        if (["assist_protime", "assist_outtime"].includes(widgetName)) {
          let res = BsyUtils.numberFormatTime(rowValue[widgetName] || null, {
            format: "dynamic",
          });
          v = res.text;
          rowValue[widgetName] = v;
          items[i1].widget.type = "text";
        }
        rowComponents[widgetName] = BsyUtils.newWidget({
          ...data,
          ...{
            designAppId: that.options.designAppId,
            designEntryId: that.options.designEntryId,
            designDataId: that.options.designDataId,
            appId: that.options.appId,
            entryId: that.options.entryId,
            formId: that.options.formId || that.options.entryId,
            subform: that.options.widgetName,
            width: "100%",
            rowIdx: rowValue.rowIdx,
            value: v,
            source: this.options.source,
            type: ["assist_protime", "assist_outtime"].includes(widgetName)
              ? "text"
              : data.type,
          },
        });

        let def = new memoryWidget({
          ...tmpitems,
          rowId: id,
          id: id,
          rowIdx: rowValue.rowIdx,
          subform: opt,
          value: v,
          formMode: opt.mode,
          field: rowComponents[widgetName],
        });
        // console.log(`make before uuid:${def.uuid} rowId:${def.rowId}`);
        def = BsyUtils.applyFunc(that, opt.onAfterWidgetCreate, [def], !1);
        // console.log(`make after uuid:${def.uuid} rowId:${def.rowId}`);
        rowComponents[widgetName]._bindField(def);
      }

      this.dataSource[i] = {
        ...rowValue,
      };
    }
    return this.dataSource;
  };

  setWidgetVisible = () => {
    // if (this.subformComponents && this.subformComponents[row] && this.subformComponents[row][widget] && this.subformComponents[row][widget].field) {
    //     this.subformComponents[row][widget].field.setVisible(val);
    // }
  };

  getWidgetVisible = (widget, row) => {
    if (widget.indexOf("_widget") === -1) {
      return true;
    }

    return this.getFieldVisible(widget, row);

    // if (
    //   this.subformComponents &&
    //   this.subformComponents[row] &&
    //   this.subformComponents[row][widget] &&
    //   this.subformComponents[row][widget].field &&
    //   this.subformComponents[row][widget].field.getVisible()
    // ) {
    //   if (
    //     this.subVisibleMap &&
    //     this.subVisibleMap[row] &&
    //     this.subVisibleMap[row][widget] === false
    //   ) {
    //     return false;
    //   } else {
    //     return true;
    //   }
    // }
    // return false;
  };

  setLinkCache = (id, name, value) => {
    this.linkCache = this.linkCache || {};
    this.linkCache[id] = this.linkCache[id] || {};
    this.linkCache[id][name] = value;
  };

  setWidgetItmesAll = (items) => {
    this.widgetItmesAll = items;
  };

  //主动更新 因为虚拟dom 某些元素可能没有刷新出来
  setItemValue = function (el) {
    var val = el.linkValue;
    if (this.dataSource[el.rowIdx]) {
      this.dataSource[el.rowIdx][el.name] = val;

      if (this.options.showMode === "dataManager") {
        if (this.subformComponents[el.rowIdx]) {
          if (this.subformComponents[el.rowIdx][el.name]) {
            this.subformComponents[el.rowIdx][el.name].setValue(val);
            // this.subformComponents[el.rowIdx][el.name].field.setValue(val, null, true);
          }
        }
      }

      if (this.dataTableField[el.rowIdx]) {
        if (this.dataTableField[el.rowIdx][el.name]) {
          this.dataTableField[el.rowIdx][el.name].setValue(
            this.dataSource[el.rowIdx][el.name]
          );
          if (this.expandContext) {
            if (this.expandContext.options.rowIdx === el.rowIdx) {
              this.expandContext.componenMap[el.name] &&
                this.expandContext.componenMap[el.name].setValue(
                  this.dataSource[el.rowIdx][el.name]
                );
            }
          }
        }
      }
    }
  };

  getLinkCache = (id, name) => {
    if (!id) {
      return {};
    }
    if (!name) {
      return {};
    }
    this.linkCache = this.linkCache || {};
    this.linkCache[id] = this.linkCache[id] || {};
    return this.linkCache[id][name] || null;
  };

  updateItemsValue = (rowIdx, widgetName, val) => {
    this.dataSource[rowIdx][widgetName] = val;
    this.subformComponents[rowIdx][widgetName].setValue(val);
    // this.subformComponents[rowIdx][widgetName].field.setValue(val);
  };

  enterAddRow = (config) => {
    if (["text", "number"].includes(config.type)) {
      let rowIdx = config.rowIdx;
      let widgetName = config.widgetName;
      let that = this;
      config.onKeyUp = function (t, val) {
        that.updateItemsValue(rowIdx, config.widgetName, val);
        let n = that.dataSource.length;
        if (
          t.keyCode === window.FX.CONST.KEY_CODE.ENTER ||
          t.which === window.FX.CONST.KEY_CODE.ENTER
        ) {
          var e = rowIdx;

          if (
            e + 1 >= n &&
            that._allowCreate() &&
            n < that.options.maxItemCount
          ) {
            that.addRow();
          } else {
            t.target.blur();
          }
          setTimeout(function () {
            var i =
              that.dataTableField[e + 1] &&
                that.dataTableField[e + 1][widgetName]
                ? that.dataTableField[e + 1][widgetName]
                : null;
            if (i) {
              i.select();
            }
          }, 100);

          // e + 1 >= n.rowIdx && n._allowCreate() && n.rowIdx < a.maxItemCount ? n._addRow() : t.target.blur();
          // var i = n.getWidgetByName(d.widgetName, e + 1);
          // i && setTimeout(function () {
          //     i.select()
          // }, 100)
        }
      };
    }
    return config;
  };

  renderCustomCell = (value, record, rowIndex, widget) => {
    let that = this;
    let data = { ...widget };
    let newValue = (this.options.enable === false || this.options.isformdata === true) ? value : this.getItemValue(data.widget.widgetName, rowIndex);
    let config = {
      ...data.widget,
      ...{
        appId: that.options.appId,
        entryId: that.options.entryId,
        formMode: that.options.formMode,
        formId: that.options.formId || that.options.entryId,
        designEntryId: this.options.designEntryId,
        designAppId: this.options.designAppId,
        designDataId: this.options.designDataId,
        subform: that.options.widgetName,
        subformDataId: record.id,
        width: "100%",
        rowIdx: rowIndex,
        value: newValue, //|| value,
        source: that.options.source,
      },
    };

    this.enterAddRow(config);

    let widgetName = config.widgetName;
    let rowIdx = rowIndex;
    switch (config.type) {
      case "combo":
      case "radiogroup":
      case "checkboxgroup":
      case "combocheck": {
        if (this.widgetItmesAll) {
          if (
            this.widgetItmesAll[rowIndex] &&
            this.widgetItmesAll[rowIndex][widgetName]
          ) {
            config.items = this.widgetItmesAll[rowIndex][widgetName];
          }
        }
        break;
      }
      case "linkquery": {
        config.onGetFilter = function () {
          return BsyUtils.applyFunc(
            that,
            that.options.onGetFilter,
            [config],
            !1
          );
        };
        break;
      }
      case "linkdata": {
        config.data = that.getLinkCache(record.id, widgetName);
        config.onAfterEdit = function (val) {
          that.setLinkCache(
            that.dataSource[rowIndex].id,
            widgetName,
            this.state.data
          );
        };
        break;
      }
      case "number": {
        config.onAfterEdit = function (val) {
          that.updateItemsValue(rowIdx, widgetName, val);
          if (config.noSingleDataRepeat) {
            that.clearItemError(rowIdx, widgetName);
          }
        };
        break;
      }
      case "text": {
        config.onAfterEdit = function (val) {
          that.updateItemsValue(rowIdx, widgetName, val);
          if (config.noSingleDataRepeat) {
            that.clearItemError(rowIdx, widgetName);
          }
        };
        break;
      }
      case "textarea": {
        config.onAfterEdit = function (val) {
          that.updateItemsValue(rowIdx, widgetName, val);
        };
        break;
      }
      // TODO 修复子表单拓展按钮没有文字bug
      case "button": {
        config.mode = "blue";
        config.text = config.text || config.labelStyle || widget.label;
        // config.click = (event, sc, triggerThis) => {
        //     BsyUtils.applyFunc(that, that.options.onStopEdit, [event, config, triggerThis], !1);
        // }
        break;
      }
      default: {
        config.onAfterEdit = function (val) {
          that.updateItemsValue(rowIdx, widgetName, val);
          if (config.noSingleDataRepeat) {
            that.clearItemError(rowIdx, widgetName);
          }
        };
      }
    }

    if (this.options.onBeforeWidgetCreate)
      //此处为抄以前的逻辑，会影响导致uuid函数多次计算 2024 01 04 波波
      config = BsyUtils.applyFunc(
        this,
        this.options.onBeforeWidgetCreate,
        [config],
        !1
      );

    config.getContext = (e) => {
      var widget = that.getSubformWidgetByName(
        widgetName,
        that.dataSource[rowIdx].id,
        rowIdx
      );
      e._bindField(widget);
      that.dataTableField[rowIdx][widgetName] = e;
    };

    config.onStopEdit = function (val, tr, trthis) {
      that.updateItemsValue(rowIdx, widgetName, val);
      switch (config.type) {
        case "user":
        case "dept":
        case "combo": {
          if (config.noSingleDataRepeat) {
            that.clearItemError(rowIdx, widgetName);
          }
          break;
        }
        case "linkdata": {
          that.setLinkCache(
            that.dataSource[rowIndex].id,
            widgetName,
            this.state.data
          );
          break;
        }
        default: {
        }
      }
      BsyUtils.applyFunc(
        that,
        that.options.onStopEdit,
        [val, config, trthis],
        !1
      );
    };

    if (this._allowCreate()) {
      if (record.isNew) {
        config.enable = config.enable === undefined ? true : config.enable;
      } else {
        config.enable = !this._allowEdit()
          ? false
          : config.enable === undefined
            ? true
            : config.enable;
      }
    } else {
      config.enable = !this._allowEdit()
        ? false
        : config.enable === undefined
          ? true
          : config.enable;
    }

    config.visible = config.visible === undefined ? true : config.visible;

    let display = "";
    // if (config.visible && this.subVisibleMap && this.subVisibleMap[rowIndex]) {
    //   if (this.subVisibleMap[rowIndex].hasOwnProperty(widgetName)) {
    //     if (this.subVisibleMap[rowIndex][widgetName] === false) {
    //       // display = " bsy-ui-hidden";
    //     }
    //   }
    // }
    let key = [config.subform, widgetName, config.config];

    let errorCls = "";

    //处理后台返回的属性
    if (this.itemsvisible) {
      if (this.itemsvisible.hasOwnProperty(widgetName)) {
        if (this.itemsvisible[widgetName] === false) {
          // display = " bsy-ui-hidden";
        }
      }
    }
    if (this.itemsenable) {
      if (rowIndex < this.itemsenable.length) {
        if (this.itemsenable[rowIndex].hasOwnProperty(widgetName)) {
          config.enable =
            this._allowEdit() && this.itemsenable[rowIndex][widgetName];
        }
      }
    }
    //处理后台返回的属性
    if (that.options.ignoreOptAuth) {
      config.visible = true;
      config.enable = true;
      display = "";
    }
    if (this.widgetErrorMap && this.widgetErrorMap.errs) {
      if (Array.isArray(this.widgetErrorMap.errs)) {
        BsyUtils.forEach(this.widgetErrorMap.errs, function (index, error) {
          if (error.name.indexOf(widgetName) > -1) {
            if (config.rowIdx == error.idx) {
              errorCls = "error";
            }
          }
        });
      } else {
        if (this.widgetErrorMap.errs[widgetName]) {
          if (this.widgetErrorMap.errs[widgetName].indexOf(config.value) > -1) {
            errorCls = "error";
          }
        }
      }
    }

    return (
      <div className={"sub-cell " + errorCls + display} key={key}>
        {this.createSubformWidget(config)}
      </div>
    );
  };

  clearItemError = (row, name) => {
    // 先过滤掉所有重复的错误
    this.errorWidgets = this.errorWidgets.filter((it) => {
      return it.errMsg !== React.language("field.noRepeat");
    });
    // 检测重复值的错误
    this.checkDataRepeat();
    // 错误值是否还存在
    let hasError = this.errorWidgets.filter((it) => {
      return it.idx == row && it.name === name;
    });
    if (!this.widgetErrorMap) this.widgetErrorMap = {};
    this.widgetErrorMap.errs = this.errorWidgets;
    const cell = this.element.current.querySelector(
      `.art-table-body .data-index-${row} .${name} .sub-cell`
    );
    if (cell) {
      if (hasError.length) {
        cell.classList.add("error");
      } else {
        cell.classList.remove("error");
      }
    }
  };

  createSubformWidget = (config, type) => {
    config.height = 34;
    // if(type === "popup"){
    //     config.height = "auto";
    // }
    switch (config.type) {
      case "textarea": {
        config.autoHeight = true;

        type === "popup" && (config.height = 144);
        return <BsyTextArea {...config} />;
      }
      case "assist_flowid": {
        return (
          <div className="sub-cell ">
            <div
              className="bsy_form_item_disable"
              data-watermark={React.language("content.empty")}
            >
              {config.value}
            </div>
          </div>
        );
      }
      case "assist_prostatus": {
        return (
          <div className="sub-cell ">
            <div
              className="bsy_form_item_disable"
              data-watermark={React.language("content.empty")}
            >
              {config.value}
            </div>
          </div>
        );
      }
      case "upload": {
        config.isformdata = this.options.isformdata;
        config.dataId = this.options.dataId;
        config.subformData = this.options.value;
        config.authGroupId = this.options.authGroupId;
        config.fileName = this.options.widgetName;
        if (type === "popup") {
          return <BsyFileUpload {...config} />;
        }

        config.customCls = " sub-cell-widget ";
        config.scene = "subform";
        return (
          <BsySubformFileUpload
            {...config}
            onGetAuth={() => {
              const { optAuth = {} } = this.props;
              const name = [config.subform, config.widgetName].join(".");
              return optAuth.hasOwnProperty(name) ? optAuth[name] : null;
            }}
          />
        );
      }

      case "image": {
        config.isformdata = this.options.isformdata;
        if (type === "popup") {
          return <BsyImageUpload {...config} />;
        }
        config.customCls = " sub-cell-widget ";
        return <BsySubformImageUpload {...config} />;
      }
      case "signature": {
        config.isformdata = this.options.isformdata;
        if (type === "popup") {
          return <BsySignature {...config} />;
        }
        config.customCls = " sub-cell-widget ";
        return <BsySubformSignature {...config} />;
      }
      case "user": {
        config.customCls = " sub-cell-widget ";
        return <BsySelectUser {...config} />;
      }
      case "dept": {
        config.customCls = " sub-cell-widget ";
        return <BsySelectDept {...config} />;
      }

      case "usergroup": {
        config.customCls = " sub-cell-widget ";
        type === "popup" && (config.height = 74);
        return <BsySelectUserGroup {...config} />;
      }
      case "deptgroup": {
        config.customCls = " sub-cell-widget ";
        type === "popup" && (config.height = 74);
        return <BsySelectDeptGroup {...config} />;
      }
      case "address": {
        config.customCls = " sub-cell-widget ";
        return <BsySubformAddress {...config} />;
      }
      case "location": {
        config.customCls = " sub-cell-widget ";
        return <BsySubformLocation {...config} />;
      }

      case "linkdata": {
        if (BsyUtils.isObjectEmpty(config.linkFields)) {
          return "";
        }
        if (type === "popup") {
          return <BsyLinkData {...config} />;
        }
        return <BsySubformLinkData {...config} />;
      }
      case "linkquery": {
        if (BsyUtils.isObjectEmpty(config.linkFields)) {
          return "";
        }
        if (type === "popup") {
          return <BsyLinkQuery {...config} />;
        }
        return <BsySubformLinkQuery {...config} />;
      }
      case "radiogroup": {
        if (type === "popup") {
          config.height = "auto";
          return <BsyRadioGroup {...config} />;
        }
        config.customCls = " sub-cell-widget ";
        return <BsySubformRadioGroup {...config} />;
      }
      case "checkboxgroup": {
        if (type === "popup") {
          config.height = "auto";
          return <BsyCheckGroup {...config} />;
        }
        config.customCls = " sub-cell-widget ";
        return <BsySubformCheckboxGroup {...config} />;
      }
      case "datetime": {
        config.customCls = " sub-cell-widget ";
        return BsyUtils.createWidget(config);
      }
      case "combocheck":
        return <BsyComboCheckBox {...config} />;
      case "combo":
        return <BsyComboBox {...config} />;

      default: {
        switch (config.widgetName) {
          case "assist_protime":
          case "assist_outtime":
            return (
              <div className="sub-cell ">
                <div
                  className="bsy_form_item_disable"
                  data-watermark={React.language("content.empty")}
                >
                  {config.value}
                </div>
              </div>
            );
          default:
            return BsyUtils.createWidget(config);
        }
      }
    }
  };

  //统一数据格式，某些数据可能会出现
  //{widget:{data:abc,visible:true}}
  unifiedValueFormat = (val) => {
    if (val && Array.isArray(val)) {
      for (let i = 0; i < val.length; i++) {
        const row = val[i];
        BsyUtils.forEach(row, (a1, b1) => {
          if (
            b1 &&
            (b1.hasOwnProperty("data") || b1.hasOwnProperty("widgetType"))
          ) {
            val[i][a1] = b1.data;
          } else {
            val[i][a1] = b1;
          }
        });
      }
      return [...val];
    }
    return [];
  };

  refreshExpand = () => {
    if (this.expandContext) {
      let rowDf = null;
      if (this.holder) {
        rowDf = parseInt(this.holder.getAttribute("row-idx"));

        if (rowDf > this.dataSource.length - 1) {
          rowDf = this.dataSource.length - 1;
        }
        this.expandContext.onSwichData(rowDf);
      }
    }
  };

  refresh = (cb) => {
    let that = this;
    if (this.field) {
      this.field.setValue(that.getObjectValue(), null, !0);
    }

    that.errorWidgets = [];
    that.widgetErrorMap = {};
    that.setInvalidateTypeText(null);
    that.checkDataRepeat();
    that.widgetErrorMap = { errs: that.errorWidgets };
    that.renderIndex++;
    that.setState(
      {
        columns: that.columns,
      },
      () => {
        this.hasXScroll();
        that.refreshExpand();
        cb && cb();
        // BsyUtils.applyFunc(that, that.options.onRenderSucess, [that.dataSource, null, that], !1);
      }
    );
  };

  moveLastRow = () => {
    console.log(" moveLastRow ");
    const { current } = this.element;
    if (!current) {
      return;
    }
    let element = current.querySelector(".chart-data-border");
    if (element) element.scrollTop = 999999;
  };

  setValue = (value, cb) => {
    this.renderIndex++;
    // console.log("subform setValue ", value, cb);
    this.clearData();
    this.value = value || [];
    this.makeData();
    let isAddRow = this.addstatus;
    if (this.addstatus) {
      this.addstatus = false;
    }

    if (this.options.showMode !== "dataManager") {
      this.refresh(() => {
        if (isAddRow) {
          this.moveLastRow();
        }
        cb && cb();
      });
    } else {
      cb && cb();
    }
  };

  getItemValue = (widget, index) => {
    let that = this;
    if (index === undefined) {
      let isWhere = true;
      let val = [];
      BsyUtils.forEach(this.dataSource, (index, item) => {
        if (!item[widget]) {
          isWhere = false;
          return false;
        }

        var widget1 = that.getSubformWidgetByName(
          widget,
          that.dataSource[index].id,
          index
        );
        var val = widget1.getValue();
        val.push(val);
      });
      if (!isWhere) {
        return null;
      }
      return val;
    }

    if (index < 0 || index > that.dataSource.length) {
      return null;
    }

    var widget1 = that.getSubformWidgetByName(
      widget,
      that.dataSource[index].id,
      index
    );

    if (["textarea","text","number"].includes(widget1.type)) {
      return that.dataSource[index][widget];
    } else {
      return widget1.getValue();
    }
  };

  getSubformWidgetByName = (widgetName, rowId, rowIdx) => {
    let that = this;
    let opt = this.options;
    let subform = opt.widgetName;
    var widget1 = null;
    if (rowId) {
      let name = [subform, rowId, widgetName].join(".");
      widget1 = BsyUtils.applyFunc(that, opt.onGetWidget, [name], !1);
      return widget1 ? widget1 : null;
    } else if (_.isNil(rowIdx)) {
      if (rowIdx >= that.dataSource.length) {
        return null;
      }
      if (rowIdx < 0) {
        return null;
      }
      widget1 = that.subformComponents[rowIdx][widgetName];
      return widget1 ? widget1 : null;
    } else {
      return null;
    }
  };

  getErrorWidgets = () => {
    return this.errorWidgets;
  };

  setViewVisibleMap = (ViewVisibleMap) => {
    this.ViewVisibleMap = ViewVisibleMap;
  };

  data2data = (type, val) => {
    switch (type) {
      case "user":
      case "dept": {
        const id = val
          ? typeof val === "string"
            ? val
            : val.id || val._id || null
          : null;
        return id;
        break;
      }
      default:
    }
    return val;
  };

  checkDataRepeat = () => {
    let that = this;
    const { isformdata } = this.options;
    if (isformdata) {
      return;
    }
    let opt = this.options;
    let items = opt.items;
    let checkRepeat = {};
    let hasError = false;
    that.errorWidgets = that.errorWidgets || [];
    BsyUtils.forEach(this.dataSource, function (i) {
      let row = i;
      BsyUtils.forEach(items, function (k, n1) {
        let index = n1.widget.widgetName;
        const type = n1.widget.type;
        if (n1.widget.noSingleDataRepeat) {
          checkRepeat[index] = checkRepeat[index] || [];
          const val = that.data2data(type, that.dataSource[row][index]);
          checkRepeat[index].push(val);
        }
      });
    });
    if (!BsyUtils.isObjectEmpty(checkRepeat)) {
      BsyUtils.forEach(checkRepeat, (key, value) => {
        const repeatValues = BsyUtils.findDuplicates(value);
        if (!BsyUtils.isObjectEmpty(repeatValues)) {
          that.setInvalidateTypeText(React.language("repeat.tip"));
          let errs = that.dataSource
            .map((it, index) => {
              const val = that.data2data(that.itemMap[key].type, it[key]);
              if (val && repeatValues.includes(val)) {
                hasError = true;
                const name = [opt.widgetName, key].join(".");
                return {
                  name: name,
                  idx: index,
                  errMsg: React.language("field.noRepeat"),
                  Required: false,
                };
              }
              return null;
            })
            .filter((it) => it);
          that.errorWidgets = that.errorWidgets.concat(errs);
        }
      });
    }
    return !hasError;
  };

  checkValidate = () => {
    let that = this;
    let opt = this.options;
    let items = opt.items;
    this.errorWidgets = [];
    that.setInvalidateTypeText(null);
    if (!this.checkDataRepeat()) {
      return false;
    }

    var val = [];
    BsyUtils.forEach(this.dataSource, function (i) {
      let row = i;

      let errs = [];
      let isempry = true;
      let rowVal = {};
      BsyUtils.forEach(items, function (k, n1) {
        let index = n1.widget.widgetName;

        let n = that.subformComponents[row][index]; // (index, row, i);

        let isVisible = that.getWidgetVisible(index, row);
        if (!isVisible) return;
        switch (n.field.type) {
          case "linkquery":
          case "button": {
            return;
          }
          default:
        }

        if (n) {
          let name = [that.options.widgetName, index].join(".");

          if (isVisible) {
            let o = n.checkValidate();
            if (!o) {
              let obj = {
                name: name,
                idx: row,
                errMsg: n.getInvalidateTypeText(),
                Required:
                  React.language("item.required") == n.getInvalidateTypeText()
                    ? true
                    : true,
              };
              errs.push(obj);
            }

            if (!BsyUtils.isObjectEmpty(n.getValue())) {
              isempry = false;
              rowVal[n.options.widgetName] = n.getValue();
            }
          }
        }
      });

      if (isempry) {
        return;
      }

      if (!BsyUtils.isObjectEmpty(rowVal)) {
        val.push(rowVal);
        if (!BsyUtils.isObjectEmpty(errs)) {
          that.errorWidgets = that.errorWidgets.concat(errs);
        }
      }
    });

    if (BsyUtils.isObjectEmpty(val)) {
      if (!opt.allowBlank) {
        this.setInvalidateTypeText(React.language("item.required"));
        return false;
      }
    }

    return BsyUtils.isObjectEmpty(that.errorWidgets) ? true : false;
  };

  getObjectValue = () => {
    let value = [];
    for (let i = 0; i < this.dataSource.length; i++) {
      let rowData = { ...this.dataSource[i] };
      value.push(rowData);
    }
    return [...value];
  };

  getText = () => {
    let that = this;
    let value = [];
    for (let i = 0; i < this.dataSource.length; i++) {
      let rowData = {};
      let isAllEmpty = true; //整行为空
      rowData.id = {
        data: this.dataSource[i].id,
        widgetType: "text",
      };
      BsyUtils.forEach(that.options.items, (key, item) => {
        var key1 = item.widget.widgetName;
        if (key1.indexOf("_widget_") > -1) {
          var widget = that.subformComponents[i][key1].field;
          switch (widget.type) {
            case "linkquery":
            case "dataload":
            case "button": {
              return;
            }
            default:
          }
          // console.log(`${widget.uuid} ${widget.label}`)
          var val = widget.getValue();
          if (widget.type === "number") {
            val = widget.getText();
          } else if (widget.type == "combocheck") {
            if (BsyUtils.isString(val)) {
              if (val.length === 0) {
                val = null;
              } else {
                val = [val];
              }
            }
          }

          if (!BsyUtils.isObjectEmpty(val)) {
            isAllEmpty = false;
          }

          rowData[key1] = {
            data: val,
            widgetType: widget.type,
            // visible: isVisible,
          };
        }
      });
      if (!isAllEmpty) {
        value.push(rowData);
      }
    }
    return [...value];
  };

  getRowValue = (row, all) => {
    let that = this;
    let isEmpty = true;
    let rowValue = {};
    BsyUtils.forEach(row, (key, val) => {
      if (key === "id" || key === "rowIdx" || key === "order") {
        return;
      }
      let d = val;
      if (!that.itemMap[key]) {
        return;
      }
      switch (that.itemMap[key].type) {
        case "dataload":
        case "linkquery":
        case "button": {
          return;
        }
        case "text":
          d = BsyUtils.toStringDetailed(val).trim();
          break;
        case "textarea":
          d = BsyUtils.toStringDetailed(val);
          break;
        default: {
          d = val;
        }
      }
      if (!all) {
        if (!BsyUtils.isObjectEmpty(d)) {
          isEmpty = false;
        }
      }

      rowValue[key] = {
        data: d,
        widgetType: that.itemMap[key].type,
      };
    });
    if (isEmpty) {
      return false;
    }
    rowValue.id = {
      data: row.id,
      widgetType: "text",
    };
    return rowValue;
  };

  eventGetValue = () => {
    let value = [];
    for (let i = 0; i < this.dataSource.length; i++) {
      let rowData = this.getRowValue(this.dataSource[i], true);
      if (rowData) {
        value.push(rowData);
      }
    }
    return [...value];
  };

  getValue = () => {
    let value = [];
    for (let i = 0; i < this.dataSource.length; i++) {
      let rowData = this.getRowValue(this.dataSource[i]);
      if (rowData) {
        value.push(rowData);
      }
    }
    return [...value];
  };

  setPipelineState = (updater) => {
    // this.setPipelineState 被调用时，第一个参数 updater 是一个函数
    // updater 接受原来的 pipelineState，返回新的 pipelineState
    this.setState(
      (prev) => ({
        pipelineState: updater(prev.pipelineState),
      }),
      () => { }
    );
  };

  onscroll = () => {
    let scrollLeft =
      this.element.current.querySelector(".art-sticky-scroll").scrollLeft;

    let left = this.element.current.querySelectorAll(
      ".chart-data-border .blank"
    );
    for (let index = 0; index < left.length; index++) {
      const element = left[index];
      if (element) {
        let el = element.previousSibling;
        if (scrollLeft == 0) el.style.borderRight = "";
        else el.style.borderRight = "none";
      }
    }
    let headerleft = this.element.current.querySelectorAll(
      ".art-table-header-row .last"
    );
    for (let index = 0; index < headerleft.length; index++) {
      const element = headerleft[index];
      if (element) {
        let el = element.previousSibling;
        if (scrollLeft == 0) el.style.borderRight = "";
        else el.style.borderRight = "none";
      }
    }
  };

  _getColSizeMapKey = () => {
    const {
      appId,
      entryId,
      widgetName,
      StoregetKey = "subformColSizeMap",
      authGroupId,
    } = this.options;
    return BsyUtils.Store.getKey(StoregetKey, {
      appId: appId,
      entryId: entryId,
      widgetId: widgetName,
      authGroupId: BsyUtils.isNumber(authGroupId) ? authGroupId : "",
    });
  };

  _getColSizeMap = () => {
    let t = this._getColSizeMapKey();
    return BsyUtils.Store.get(t) || {};
  };
  _updateColSize = (val) => {
    const { columns } = this.state;
    let columnResize = {};
    let columnIndex = 0;
    for (let i = 0; i < columns.length; i++) {
      if (columns[i].widgetType == "subform") {
        let children = columns[i].children;
        for (let ichild = 0; ichild < children.length; ichild++) {
          columnResize[children[ichild].code] = val[columnIndex];
          columnIndex++;
        }
      } else {
        columnResize[columns[i].code] = val[columnIndex];
        columnIndex++;
      }
    }

    let i = this._getColSizeMapKey();
    BsyUtils.Store.set(i, columnResize);
  };

  //处理数据
  pipeline = () => {
    // console.log("pipeline")
    if (this.element.current) {
      let atb = this.element.current.querySelector(".art-sticky-scroll");
      if (atb) {
        atb.removeEventListener("scroll", this.onscroll);
        atb.addEventListener("scroll", this.onscroll, false);
      }
    }

    let { columns } = this.state;
    const pipeline = new TablePipeline({
      ctx: { components: { Checkbox: BsyCheckBox } },
      state: this.state.pipelineState,
      setState: this.setPipelineState,
    });
    // console.log("dataSource", this.dataSource);
    //处理后端返回的值
    this.makeHeader();
    columns = this.columns;

    //处理后端返回的值
    pipeline.input({ dataSource: [...this.dataSource], columns });
    pipeline.primaryKey("rowId");
    //列之间拖动
    pipeline.use(
      features.columnResize({
        defaultSizes: this.lastcolumnResize,
        /** 受控用法：列宽数组 */
        sizes: this.lastcolumnResize,
        onChangeSizes: () => {
          // console.log('onChangeSizes', size)
          let resize = this.element.current.querySelector(
            ".column-resizer-line"
          );
          if (resize) {
            resize.style.display = "none";
          }

          setTimeout(() => {
            //做1个像素偏移，防止头部错位，取巧的解决方式，具体原因找不到
            let scroll =
              this.element.current.querySelector(".art-sticky-scroll");
            let scrollLeft = scroll.scrollLeft;
            // console.log('scrollLeft', scrollLeft);
            scroll.scrollLeft = scrollLeft + (scrollLeft > 0 ? -1 : 1);
            scroll.scrollLeft = scrollLeft;
          }, 32);
        },
        onChnageSizePos: (sizes, pos) => {
          // console.log('onChnageSizePos', sizes)
          // console.log(sizes.slice(0, pos + 1))
          this.lastcolumnResize = [...sizes];
          this._updateColSize([...sizes]);

          let sumValue = sizes.slice(0, pos + 1).reduce(function (sum, number) {
            //sum2 前两个数的和

            return sum + number;
          }, 0);

          let scrollLeft =
            this.element.current.querySelector(".art-sticky-scroll").scrollLeft;
          let resizer = this.element.current.querySelector(
            ".column-resizer-line"
          );
          if (resizer) {
            resizer.style.display = "block";
            resizer.style.left = sumValue - scrollLeft - 3 + "px";
          }
        },
        fallbackSize: 100,
        minSize: 50,
        handleBackground: "#ddd",
        handleHoverBackground: "#aaa",
        handleActiveBackground: "#89bff7",
      })
    );
    return pipeline.getProps();
  };

  rowHoverEnter = (dataIndex) => {
    const { widgetName } = this.options;

    let dd = document.querySelectorAll(
      `.bsy-subform.${widgetName} .data-index-${dataIndex}:not(.hover)`
    );
    let n = dd.length;

    for (let i = 0; i < n; i++) {
      dd[i].classList.add("hover");
    }
  };

  rowHoverLeave = (dataIndex) => {
    // console.log('rowHoverLeave')
    const { widgetName } = this.options;

    let dd = document.querySelectorAll(
      `.bsy-subform.${widgetName} .data-index-${dataIndex}`
    );
    let n = dd.length;

    for (let i = 0; i < n; i++) {
      dd[i].classList.remove("hover");
    }
  };

  getItemDefaultValue = (item) => {
    if (!item) return null;

    switch (item.type) {
      case "combocheck":
      case "checkboxgroup": {
        let value = [];

        if (BsyUtils.isEmpty(item.value)) {
          if (item.items) {
            for (let i = 0; i < item.items.length; i++) {
              if (item.items[i].selected) {
                value.push(item.items[i].value);
              }
            }
            return BsyUtils.isObjectEmpty(value) ? null : value;
          } else {
            return item.value;
          }
        }
        return item.value;
        break;
      }

      case "subform_radiogroup":
      case "subform_combo":
      case "radiogroup":
      case "combo": {
        let value = "";
        if (BsyUtils.isEmpty(item.value)) {
          if (item.items) {
            for (let i = 0; i < item.items.length; i++) {
              if (item.items[i].selected) {
                if (item.items[i].isOther) {
                  value = null;
                } else {
                  value = item.items[i].value;
                }
                // delete item.items[i].selected;
                return value;
              }
            }
            return BsyUtils.isObjectEmpty(value) ? null : value;
          } else {
            return item.value;
          }
        }
        return item.value;
        break;
      }
      case "usergroup":
      case "user": {
        window.userSelectMap = window.userSelectMap || {};
        BsyUtils.forEach(item.items, function (svitem) {
          var id = svitem.id || svitem._id;
          window.userSelectMap[id] = svitem;
        });
        if (item.type === "user") {
          if (item.value === "100000000000000000000001") {
            if (window.FX.STATIC.FTOKEN) {
              return "";
            }
            return (
              window.userSelectMap[item.value].id ||
              window.userSelectMap[item.value]._id
            );
          }
          return item.value;
        }
        if (!BsyUtils.isObjectEmpty(item.value)) {
          return item.value
            .map((it) => {
              if (it === "100000000000000000000001") {
                if (window.FX.STATIC.FTOKEN) {
                  return null;
                }
                return (
                  window.userSelectMap[it].id ||
                  window.userSelectMap[it]._id ||
                  null
                );
              }
              return it;
            })
            .filter((it) => it);
        }
        return item.value;
      }
      case "dept":
      case "deptgroup": {
        window.deptSelectMap = window.deptSelectMap || {};
        BsyUtils.forEach(item.items, function (svitem) {
          var id = svitem.id || svitem._id;
          window.deptSelectMap[id] = svitem;
        });
        if (item.type === "dept") {
          if (item.value === "110000000000000000000001") {
            if (window.FX.STATIC.FTOKEN) {
              return null;
            }

            if (window.localDevInfo.user.current_departments.length > 0) {
              return (
                window.localDevInfo.user.current_departments[0].id ||
                window.localDevInfo.user.current_departments[0]._id
              );
            }

            return window.deptSelectMap["110000000000000000000001"] &&
              window.deptSelectMap["110000000000000000000001"].length
              ? window.deptSelectMap["110000000000000000000001"][0].id ||
              window.deptSelectMap["110000000000000000000001"][0]._id
              : null;
          }
          return item.value;
        }
        const current_departments = (item.value || [])?.includes(
          "110000000000000000000001"
        )
          ? window.FX.STATIC.FTOKEN
            ? []
            : window.localDevInfo.user.current_departments?.map((it) => {
              return it._id || it.id;
            }) || []
          : [];

        const current_sub_departments = (item.value || [])?.includes(
          "110000000000000000000002"
        )
          ? window.FX.STATIC.FTOKEN
            ? []
            : window.localDevInfo.user.current_sub_departments?.map((it) => {
              return it._id || it.id;
            }) || []
          : [];
        const v = (item.value || [])?.map((i) => {
          if (
            i.id === "110000000000000000000001" ||
            i === "110000000000000000000001"
          ) {
            return null;
          }
          if (
            i.id === "110000000000000000000002" ||
            i === "110000000000000000000002"
          ) {
            return null;
          }
          return i.id || i;
        });

        const v2 = [...v, ...current_departments, ...current_sub_departments];
        return v2.filter((it) => it);
      }
      case "datetime": {
        if (item.value === "today") {
          var c = new Date();
          if (c) {
            c = dayjsUtils.timeToTZ(c);
            c = BsyUtils.getFormatDate(c, item.format);
            c = dayjsUtils.timeToLocal(c).date;
          }
          item.value = c.getTime();
        }
        return item.value;
        break;
      }
      default: {
        return item.value;
      }
    }
  };

  addRow = () => {
    let i = this.dataSource.length;
    let that = this;

    if (i >= that.options.maxItemCount) {
      tipAlert({
        type: "warning",
        msg: React.language("subform.maxCountTip", {
          limit: that.options.maxItemCount,
        }),
      });
      return;
    }

    that.addstatus = true;
    this.value = this.dataSource;
    // var id = BsyUtils.Ids24();
    let v = {
      // rowId: id,
      // id: id,
      rowIdx: i,
      order: i + 1,
      isNew: true,
      status: "new",
    };
    this.value.push(v);
    this.dataSource = [...this.value];

    BsyUtils.applyFunc(
      this,
      this.options.onStopEdit,
      [this.getValue(), null, this],
      !1
    );
  };

  getexpandContext = (context) => {
    this.expandContext = context;
  };

  getFieldVisible = (name, row) => {
    const { items, ignoreOptAuth } = this.options;
    if (ignoreOptAuth) return true;
    const item = items.find((item) => item.widget.widgetName === name);

    // 整列隐藏
    if (this.itemsvisible && this.itemsvisible.hasOwnProperty(name))
      return this.itemsvisible[name];

    if (item.widget.hasOwnProperty("visible") && !item.widget.visible) {
      return false;
    }
    // 整列隐藏
    if (this.subColumnVisibleMaps && this.subColumnVisibleMaps[name] === true) {
      return false;
    }

    if (BsyUtils.isNumber(row)) {
      //指定位置隐藏
      if (
        this.subVisibleMap &&
        this.subVisibleMap[row] &&
        this.subVisibleMap[row][name] === false
      )
        return false;
    }

    return true;
  };

  getFieldEnable = (name, row) => {
    const { items, ignoreOptAuth } = this.options;
    if (ignoreOptAuth) return true;
    const item = items.find((item) => item.widget.widgetName === name);

    //指定位置隐藏
    if (
      this.itemsenable &&
      this.itemsenable[row] &&
      this.itemsenable[row].hasOwnProperty(name)
    )
      return this.itemsenable[row][name];

    if (item.widget.hasOwnProperty("enable") && !item.widget.enable) {
      return false;
    }

    return true;
  };
  getFieldItems = (name, row) => {
    const { items } = this.options;
    const item = items.find((item) => item.widget.widgetName === name);

    //指定位置隐藏
    if (
      this.widgetItmesAll &&
      this.widgetItmesAll[row] &&
      this.widgetItmesAll[row][name]
    )
      return this.widgetItmesAll[row][name];

    if (item.widget.items) {
      return item.widget.items;
    }

    return undefined;
  };
  getFieldLabel = (name) => {
    const { items } = this.options;
    const item = items.find((item) => item.widget.widgetName === name);
    return this.itemslabel &&
      this.itemslabel.hasOwnProperty(item.widget.widgetName)
      ? this.itemslabel[item.widget.widgetName]
      : item.widget.labelStyle || item.label;
  };

  // 获取当前行的 显隐，可编辑的权限
  getRowNowItem = (row) => {
    const { items } = this.options;
    return items.map((item) => {
      const label = this.getFieldLabel(item.widget.widgetName);
      const visible = this.getFieldVisible(item.widget.widgetName, row);
      const enable =
        this._allowEdit() && this.getFieldEnable(item.widget.widgetName, row);
      const ditems = this.getFieldItems(item.widget.widgetName, row);

      const newIt = Object.assign(
        {},
        {
          ...item,
          label: label,
          widget: {
            ...item.widget,
            labelStyle: label,
            visible: visible,
            enable: enable,
            items: ditems ? [...ditems] : ditems,
          },
        }
      );
      // console.log(`getRowNowItem ${label}`, newIt);
      return newIt;
    });
  };

  expandRow = (row) => {
    const {
      rootElement,
      appId,
      formId,
      ignoreOptAuth,
      text,
      label,
      labelStyle,
    } = this.options;
    let data = this.dataSource[row];
    let that = this;
    if (rootElement) {
      this.holder = document.createElement("div");
      this.holder.classList.add("bsy-subform-row-editor");
      this.holder.classList.add("popup-subform");
      this.holder.classList.add(this.styleId);
      this.holder.style.zIndex = window.FX.STATIC.zIndex++;
      this.holder.setAttribute("row-idx", row);

      function onClose(e) {
        ReactDOM.unmountComponentAtNode(that.holder);
        that.holder.removeEventListener("click", onClose, false);
        that.holder.remove();
        that.holder = null;
        that.getexpandContext(null);
      }

      if (this.isfullscreen) {
        document.querySelector("body").appendChild(this.holder);
      } else {
        rootElement.appendChild(this.holder);
      }

      let newItems = that.getRowNowItem(row);

      let config = {
        appId,
        formId,
        items: newItems,
        dataId: data.id,
        ignoreOptAuth: ignoreOptAuth,
        data,
        index: row,
        label: text || label || labelStyle,
        rowIdx: row,

        subformHandle: this,
        count: this.dataSource.length,
        onAfterEdit: (val, config, index) => {
          that.updateItemsValue(index, config.widgetName, val);
          if (config.type === "text") {
            that.subformComponents[index][config.widgetName].field.setValue(
              val
            );
          }
        },
        onRowStopEdit: (val, config, index) => {
          that.updateItemsValue(index, config.widgetName, val);
          // that.dataSource[index][config.widgetName] = val;
          // that.subformComponents[index][config.widgetName].field.setValue(val)
          BsyUtils.applyFunc(
            that,
            that.options.onStopEdit,
            [val, config, that.subformComponents[index][config.widgetName]],
            !1
          );
        },
        subVisibleMap: that.subVisibleMap || [],
        onSwichData: (index) => {
          this.holder.setAttribute("row-idx", index);
          BsyUtils.writeStyle(this.styleId, this.getCSS(index));
          this.updateScRoll();
          return {
            value: that.dataSource[index],
            items: that.getRowNowItem(row),
            cb: () => {
              this._updateRowEditor();
            },
          };
        },
        onClose: onClose,
      };

      ReactDOM.render(
        <BsySubformDataPopup {...config} getContext={this.getexpandContext} />,
        this.holder
      );
      BsyUtils.writeStyle(this.styleId, this.getCSS(row));
      this.updateScRoll();
    }
  };

  _allowCreate = () => {
    let t = this.options;
    return t.design || t.ignoreOptAuth || t.subform_create;
  };
  _allowEdit = () => {
    let t = this.options;
    return t.design || t.ignoreOptAuth || t.subform_edit;
  };

  _allowDelete = () => {
    let t = this.options;
    return t.design || t.ignoreOptAuth || t.subform_delete;
  };

  _allowInsert = () => {
    var t = this.options;
    return (
      t.design || t.ignoreOptAuth || (this._allowCreate() && t.subform_insert)
    );
  };

  _isRowEmpty = (e) => {
    let that = this;
    let opt = this.options;
    let i = !1;

    for (let index = 0; index < opt.items.length; index++) {
      let name = opt.items[index].widget.widgetName;
      if (e && e[name]) {
        let rowName = [that.options.widgetName, e.rowId, name].join(".");
        let n = BsyUtils.applyFunc(
          that,
          that.options.onGetWidget,
          [rowName],
          !1
        );
        if (!BsyUtils.isObjectEmpty(n.getValue())) {
          i = !0;
          break;
        }
      }
    }

    // BsyUtils.forEach(e, function (e1, a) {

    //     if (e1.indexOf('_widget_') > -1) {
    //         let name = [that.options.widgetName, e.rowId, e1].join('.');
    //         let n = BsyUtils.applyFunc(that, that.options.onGetWidget,
    //             [name], !1);
    //         ;

    //         if (!BsyUtils.isObjectEmpty(n.getValue())) {
    //             i = !0;
    //             return false;
    //         }
    //     }
    // });
    return i;
  };

  _rowEveryEmpty(row) {
    let that = this;
    const datas = Object.entries(row).filter(
      ([key]) => key.indexOf("_widget_") > -1
    );
    if (datas.length) {
      return datas.every(([key]) => {
        let name = [that.options.widgetName, row.rowId, key].join(".");
        let n = BsyUtils.applyFunc(that, that.options.onGetWidget, [name], !1);
        if (!n) {
          return true;
        }
        return BsyUtils.isObjectEmpty(n.getValue());
      });
    }
    return true;
  }

  delRow = (row, event) => {
    let that = this;
    let opt = this.options;

    function del(row) {
      for (let index = 0; index < opt.items.length; index++) {
        const element = opt.items[index].widget;
        let field = that.getSubformWidgetByName(
          element.widgetName,
          that.dataSource[row].rowId,
          row
        );
        BsyUtils.applyFunc(that, opt.onDeleteRow, [field], !1);
      }

      that.dataSource.splice(row, 1);
      that.renderDataSource();
      that.renderIndex++;

      BsyUtils.applyFunc(
        that,
        that.options.onStopEdit,
        [null, {}, that, "subform-delete"],
        !1
      );
      // that.setState({}, () => {
      //   that.showField();
      //   BsyUtils.applyFunc(
      //     that,
      //     that.options.onStopEdit,
      //     [null, {}, that, "subform-delete"],
      //     !1
      //   );
      // });
    }

    if (this.dataSource.length > row) {
      if (this._isRowEmpty(this.dataSource[row])) {
        const posElement = BsyUtils.closest(event.target, "div");
        BsyMsgBubble({
          anchor: posElement,
          contentHTML: (ref) => {
            return (
              <>
                <div className="content" style={{ padding: "10px" }}>
                  <div style={{ maxWidth: "210px" }}>
                    {" "}
                    {React.language("subform.dataExistTip")}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      margin: "10px 0",
                    }}
                  >
                    <BsyIconBtn
                      text={React.language("cancel")}
                      click={() => {
                        ref.closeAlter();
                      }}
                    />
                    <BsyIconBtn
                      text={React.language("delete")}
                      click={() => {
                        del(row);
                        ref.closeAlter();
                      }}
                      mode={"red"}
                    />
                  </div>
                </div>
              </>
            );
          },

          theme: this.props.theme,
          minWidth: 150,
          width: 230,
          contentPadding: 0,
          edge: 200,
          hAdjust: 72,
          dockPosition: "left",
          onClose: function () {
            return !1;
          },
        });
      } else {
        del(row);
      }
    }
  };

  //重置最新的数据id与行号
  renderDataSource = () => {
    for (let index = 0; index < this.dataSource.length; index++) {
      let element = this.dataSource[index];
      let id = element.id || element.rowId || BsyUtils.Ids24();
      element.id = id;
      element.rowId = id;

      element.rowIdx = index;
      element.order = index + 1;
      this.dataSource[index] = { ...element };
    }
  };

  excelImport = () => {
    let b = this,
      c = this.options;
    let config = {
      limit: c.maxItemCount,
      fields: this.options.items,
      onRsyncData: (val) => {
        let field = this.field;
        field.setValue(val, () => {
          if (field && field.extendSet && field.extendSet.version == 1) {
          } else {
            field.form.rowRely.batchRowRely(field);
          }
        });
      },
      onFinish: (data) => {
        BsyUtils.applyFunc(b, c.onAfterImport, [data, null, b], !1);
      },
    };

    BsyDialog({
      title: React.language("import.excel"),
      height: 600,
      width: 966,
      noFooter: true,
      onContentCreate: (e) => {
        return (
          <BsySubformImportPane
            {...config}
            onClost={() => {
              e.closeAlter();
            }}
          />
        );
      },
    });
  };

  toFromData = (selectData, type, cb) => {
    const { loaddataconfig, maxItemCount } = this.options;
    let mapFields = loaddataconfig.mapFields;
    let all = [];

    BsyUtils.forEach(selectData, (indexk, dataV) => {
      let rwodata = {};
      BsyUtils.forEach(mapFields, (index, field) => {
        if (field.mode == "custom") {
          rwodata[field.field] = field.value;
        } else if (field.mode == "empty") {
          rwodata[field.field] = null;
        } else {
          switch (field.type) {
            case "user":
            case "dept":
            case "usergroup":
            case "deptgroup":
            case "location":
            case "image":
            case "signature":
            case "upload":
            case "address": {
              try {
                if (BsyUtils.isString(dataV[field.depend.field])) {
                  rwodata[field.field] = JSON.parse(dataV[field.depend.field]);
                } else {
                  rwodata[field.field] = dataV[field.depend.field];
                }
              } catch (error) {
                rwodata[field.field] = null;
              }
              break;
            }
            default: {
              rwodata[field.field] = dataV[field.depend.field];
              break;
            }
          }
          // rwodata[field.field] = dataV[field.depend.field]
        }
      });
      all.push(rwodata);
    });
    if (type === "add") {
      if (this.dataSource.length + all.length > maxItemCount) {
        tipAlert({
          type: "warning",
          msg: React.language("subform.maxCountTip", {
            limit: maxItemCount,
          }),
        });
        return;
      }

      this.dataSource = [...this.dataSource, ...all];
    } else {
      if (all.length >= maxItemCount) {
        tipAlert({
          type: "warning",
          msg: React.language("subform.maxCountTip", {
            limit: maxItemCount,
          }),
        });
        return;
      }

      let newData = [];
      for (let i = 0; i < all.length; i++) {
        if (i < this.dataSource.length) {
          newData.push({
            ...this.dataSource[i],
            ...all[i],
            isNew: undefined,
            status: undefined,
          });
        } else newData.push({ ...all[i] });
      }
      this.dataSource = [...newData];
    }
    // this.options.value = this.dataSource;
    // this.makeData();
    this.field.setValue(this.dataSource, cb);
    this.toDataVisible();
    return all;
  };

  toDataVisible = () => {
    this.dataVisibleMap = [];
    for (let index = 0; index < this.dataSource.length; index++) {
      let row = {};
      this.dataVisibleMap.push(row);
    }
  };

  setError = (error) => {
    if (
      BsyUtils.isObjectEmpty(this.widgetErrorMap) &&
      BsyUtils.isObjectEmpty(error)
    ) {
      return;
    }

    if (!_.isEqual(this.widgetErrorMap, error)) {
      this.widgetErrorMap = error;
      this.renderIndex++;
      this.setState({}, () => {
        // this.showField();
        this.hasXScroll();
      });
    }
  };

  batchDelete = () => {
    const { selectDataId, isCheckAll } = this.state;
    let that = this;
    let opt = this.options;
    function del(row) {
      for (let index = 0; index < opt.items.length; index++) {
        const element = opt.items[index].widget;
        let field = that.getSubformWidgetByName(
          element.widgetName,
          that.dataSource[row].rowId,
          row
        );
        BsyUtils.applyFunc(that, opt.onDeleteRow, [field], !1);
      }

      that.dataSource.splice(row, 1);
      that.renderDataSource();
    }
    const indexs = selectDataId
      .map((it) => {
        return that.dataSource.findIndex((row) => {
          return row.id === it;
        });
      })
      .filter((it) => it > -1)
      .sort((a, b) => {
        return b - a;
      });
    // .reverse();

    const isempty = () => {
      return (
        indexs.filter((it) => {
          return !this._isRowEmpty(this.dataSource[it]);
        }).length === indexs.length
      );
    };

    if (isempty()) {
      indexs.map((it) => {
        del(it);
        return null;
      });
      that.setState(
        {
          selectDataId: [],
          isCheckAll: false,
          isBatchDelete: isCheckAll ? false : true,
        },
        () => {
          // that.showField();
          this.hasXScroll();
          BsyUtils.applyFunc(
            that,
            that.options.onStopEdit,
            [null, {}, that, "subform-delete"],
            !1
          );
        }
      );
    } else {
      BsyAlert({
        title: React.language("dataTable.deleteAllSelectDataTip"),
        msg: React.language("select.delete.data", { num: indexs.length }),
        type: "warning",
        text4Ok: React.language("ok"),
        OkType: "red",
        text4Cancel: React.language("cancel"),
        ok: () => {
          indexs.map((it) => {
            del(it);
            return null;
          });
          that.setState(
            {
              selectDataId: [],
              isCheckAll: false,
              isBatchDelete: isCheckAll ? false : true,
            },
            () => {
              // that.showField();
              that.hasXScroll();
              BsyUtils.applyFunc(
                that,
                that.options.onStopEdit,
                [null, {}, that, "subform-delete"],
                !1
              );
            }
          );
        },
      });
    }
  };

  hasXScroll = () => {
    if (this.element.current) {
      const stickyScroll =
        this.element.current.querySelector(".art-sticky-scroll");
      let height = 0;
      if (stickyScroll && stickyScroll.style) {
        if (stickyScroll.style.display === "none") {
          stickyScroll.style.display = "block";
          height = stickyScroll.offsetHeight;
          stickyScroll.style.display = "none";
        } else {
          height = stickyScroll.offsetHeight;
        }

        if (height > 1) {
          this.element.current
            .querySelector(".chart-data-border")
            .classList.remove("not-x-scroll");
        } else {
          this.element.current
            .querySelector(".chart-data-border")
            .classList.add("not-x-scroll");
        }
      }

      // hide-last-row
      // hide-last-row
      let s = 0;
      let h = 0;
      if (this.element.current.querySelector(".chart-data-border")) {
        s =
          this.element.current.querySelector(".chart-data-border").scrollHeight;

        h =
          this.element.current.querySelector(".chart-data-border").offsetHeight;
        if (s <= h) {
          this.element.current
            .querySelector(".chart-data-border")
            .classList.add("hide-last-row");
        } else {
          this.element.current
            .querySelector(".chart-data-border")
            .classList.remove("hide-last-row");
        }
      }
    }
    return false;
  };

  render() {
    const {
      cssName,
      allowImport,
      subform_import,
      allowLoadData,
      subform_dataload,
      loaddataconfig,
      subformloaddataTitle,
      appId,
      entryId,
      formId,
      widgetName,
      items,
      sortable,
    } = this.options;
    let that = this;
    const { isBatchDelete, selectDataId } = this.state;

    if (!items || items.length === 0) {
      return (
        <div className={cssName + " items-empty"} ref={this.element}>
          {React.language("field.add")}
        </div>
      );
    }

    return (
      <div className={`${cssName} ${this.styleId}`} ref={this.element}>
        <div
          className={"menu"}
          style={{
            display:
              (allowImport && subform_import) ||
                (allowLoadData &&
                  subform_dataload &&
                  !BsyUtils.isObjectEmpty(loaddataconfig))
                ? ""
                : "none",
          }}
        >
          {allowImport && subform_import ? (
            <BsyIconBtn
              key={"ok" + new Date().getTime()}
              text={React.language("widget.file.select")}
              click={this.excelImport}
              mode={window.mode}
              iconName="icon-subform-select-file"
            ></BsyIconBtn>
          ) : (
            ""
          )}
          {allowLoadData &&
            subform_dataload &&
            !BsyUtils.isObjectEmpty(loaddataconfig) ? (
            <BsyFormLoadData
              text={subformloaddataTitle || React.language("data.loading")}
              loaddataconfig={loaddataconfig}
              widget={widgetName}
              appId={appId}
              formId={formId}
              entryId={entryId}
              isSubform={true}
              subform={widgetName}
              onSelectData={(e, type) => {
                if (
                  type === "add" &&
                  that.dataSource.length === 1 &&
                  this._rowEveryEmpty(that.dataSource[0])
                ) {
                  type = "cover";
                }
                that.toFromData(e, type, () => {
                  BsyUtils.applyFunc(
                    that,
                    that.options.onSetFormValue,
                    [e, type],
                    !1
                  );
                });
              }}
              onGetFormData={() => {
                return this.props.onGetFormData();
              }}
            />
          ) : (
            ""
          )}
        </div>
        <div
          className={`chart-data-border ${this.dataSource.length === 0 ? "table-empty" : ""
            } `}
          style={{
            overflowX: "hidden",
            overflowY: "auto",
            height:
              (allowImport && subform_import) ||
                (allowLoadData &&
                  subform_dataload &&
                  !BsyUtils.isObjectEmpty(loaddataconfig))
                ? "calc( 100% - 80px )"
                : "calc( 100% - 40px )",
          }}
        >
          <BaseTable
            useVirtual={sortable ? false : { vertical: 30 }} //虚拟行开关
            useOuterBorder={false}
            stickyMode={"css"}
            components={{
              EmptyContent: () => {
                return (
                  <tr
                    className="art-table-row first last no-hover"
                    data-rowindex="0"
                  >
                    <td
                      className="art-table-cell first last"
                      colSpan="6"
                      style={{ height: 200 }}
                    >
                      <div className="art-empty-wrapper">
                        <tr></tr>{" "}
                      </div>
                    </td>
                  </tr>
                );
              },
              Row: ({ row, trProps }) => {
                let className = trProps.className;
                className += `data-index-${row.rowIdx} `;
                className = className.replace("odd", "");
                className = className.replace("even", "");
                if (row.rowIdx % 2 === 0) {
                  className += "even";
                } else {
                  className += "odd";
                }

                return (
                  <tr
                    {...trProps}
                    onMouseEnter={() => {
                      this.rowHoverEnter(row.rowIdx);
                    }}
                    onMouseMove={() => {
                      this.rowHoverEnter(row.rowIdx);
                    }}
                    onMouseLeave={() => {
                      this.rowHoverLeave(row.rowIdx);
                    }}
                    rowidx={row.rowIdx}
                    rowid={row._id}
                    className={className}
                  />
                );
              },

              Cell: ({ row, rowIndex, column, colIndex, tdProps }) => {
                tdProps.className = `${tdProps.className} ${column?.customCls || ""
                  } ${column.widgetType} ${column.code
                  } row-${rowIndex} col-${colIndex} row-${rowIndex}-${column.code
                  }`;
                return <td {...tdProps} />;
              },
            }}
            {...this.pipeline()}
          />
        </div>
        {!isBatchDelete && this._allowCreate() ? (
          <BsyButton
            text={React.language("add")}
            iconName={"icon-bsy-add"}
            click={() => {
              this.addRow();
            }}
            mode={window.mode}
          />
        ) : (
          ""
        )}
        {this._allowDelete() && isBatchDelete ? (
          <div style={{ marginTop: 10 }}>
            <BsyIconBtn
              text={React.language("cancel")}
              click={() => {
                this.setState({ isBatchDelete: false, selectDataId: [] });
              }}
              mode={"white"}
            />

            <BsyIconBtn
              key={"delete" + new Date().getTime()}
              style={{ marginLeft: 6 }}
              text={"删除选中的"}
              enable={!BsyUtils.isObjectEmpty(selectDataId)}
              click={() => {
                this.batchDelete();
              }}
              mode={"red"}
            />
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export class BsySubformDataPopup extends BsyWidget {
  constructor(props) {
    super({
      baseCls: "edit-content",
      ...props,
    });

    this.state = {};
    this.visibleMap = props.subVisibleMap[props.index];
    this.componenMap = {};
    this.switch_index = 0;
  }

  closeAlter = () => {
    this.props.onClose && this.props.onClose();
  };

  setValue(widget, value) {
    if (this.componenMap[widget]) {
      this.componenMap[widget].setValue(value);
    }
  }

  // designEntryId: this.options.designEntryId,
  // designAppId: this.options.designAppId,
  // subform: that.options.widgetName,

  renderCell = (item) => {
    const { index, data, ignoreOptAuth } = this.options;
    let that = this;
    let value = data[item.widget.widgetName];
    let subformHandle = this.props.subformHandle;
    let config = {
      ...item.widget,
      ...{
        appId: that.options.appId,
        entryId: that.options.entryId,
        formMode: that.options.formMode,
        formId: that.options.formId || that.options.entryId,
        subform: subformHandle.options.widgetName,
        designEntryId: subformHandle.options.designEntryId,
        designAppId: subformHandle.options.designAppId,
        width: "100%",
        rowIdx: index,
        value: value,
        label: item.label,
      },
    };
    config.ref = (el) => {
      this.componenMap[item.widget.widgetName] = el;
      // TODO 解决子表单展开后点缩小报错
      this.componenMap[item.widget.widgetName]?._bindField(
        subformHandle.subformComponents[index][item.widget.widgetName].field
      );
    };
    if (subformHandle.options.onBeforeWidgetCreate)
      config = BsyUtils.applyFunc(
        subformHandle,
        subformHandle.options.onBeforeWidgetCreate,
        [config, undefined, item],
        !1
      );
    if (config.type == "button") {
      config.mode = "blue";
      config.text = config.text || config.labelStyle || item.label;
    }

    config.onAfterEdit = function (val) {
      BsyUtils.applyFunc(
        that,
        that.options.onAfterEdit,
        [val, config, index],
        !1
      );
    };

    config.onFormEvent = function (val) {
      BsyUtils.applyFunc(
        that,
        that.options.onRowStopEdit,
        [val, config, index],
        !1
      );
    };

    config.onStopEdit = function (val) {
      BsyUtils.applyFunc(
        that,
        that.options.onRowStopEdit,
        [val, config, index],
        !1
      );
    };

    // config.enable = !subformHandle._allowEdit() ? false : config.enable ===
    //     undefined ? true : config.enable;

    if (subformHandle._allowCreate()) {
      if (data.isNew) {
        config.enable = config.enable === undefined ? true : config.enable;
      } else {
        config.enable = !subformHandle._allowEdit()
          ? false
          : config.enable === undefined
            ? true
            : config.enable;
      }
    } else {
      config.enable = !subformHandle._allowEdit()
        ? false
        : config.enable === undefined
          ? true
          : config.enable;
    }

    config.getContext = null;
    if (config.labelHidden === true) {
    }
    if (ignoreOptAuth) {
      config.enable = true;
    }
    config.visible = true;
    return (
      <div
        key={item.widget.widgetName}
        className={"subform-cell " + config.widgetName}
      >
        <div className="fl-label">
          {config.labelHidden === true ? (
            ""
          ) : (
            <>
              <span
                className="label-title"
                dangerouslySetInnerHTML={{
                  __html: config.labelStyle || config.label,
                }}
              ></span>
              {config.allowBlank === false ? (
                <span className="label-notnull">*</span>
              ) : (
                ""
              )}
            </>
          )}
        </div>
        <div className="fl-widget">
          {subformHandle.createSubformWidget(config, "popup")}
        </div>
      </div>
    );
  };

  onSwichData = (index) => {
    if (index < 0) {
      return;
    }
    if (index >= this.options.count) {
      return;
    }

    let { value, items, cb } = this.props.onSwichData(index);
    this.options.index = index;
    this.options.data = value;
    this.options.items = items;
    this.visibleMap = this.options.subVisibleMap[index];
    this.switch_index++;
    this.setState({}, () => {
      cb && cb();
    });
  };

  render() {
    const { cssName, index, count, items, labelStyle, label } = this.options;

    return (
      <div className={cssName}>
        <div className="row-title">
          <span className="label">
            {labelStyle || label || React.language("widget.subform")}
          </span>
          <i className="close-btn icon-contract" onClick={this.closeAlter}></i>
          <div className="switch-pane">
            <div
              className={"switch-btn prev " + (index == 0 ? "disabled" : "")}
              onClick={() => {
                this.onSwichData(index - 1);
              }}
            >
              <i className="icon-angleleft"></i>
            </div>
            <div className="switch-num">
              {index + 1}/{count}
            </div>
            <div
              className={
                "switch-btn next  " + (index == count - 1 ? "disabled" : "")
              }
              onClick={() => {
                this.onSwichData(index + 1);
              }}
            >
              <i className="icon-angleright"></i>
            </div>
          </div>
        </div>
        <div className="subform-row" key={"subform-row" + this.switch_index}>
          {items.map((item) => {
            return this.renderCell(item);
          })}
        </div>
      </div>
    );
  }
}
